<template>
  <content-view>
    <div>
      1111
    </div>
  </content-view>
</template>

<script type="text/javascript">
export default {
  name: "food",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss">
</style>